import PartnerDetails from "./PartnerDetails";

export default PartnerDetails;